<template>
  <v-data-table
    :expanded="expanded"
    :headers="headerList"
    :items="entityList"
    class="transparent"
    disable-pagination
    hide-default-footer
    item-key="importKey"
  >
    <template v-slot:item="{ headers, item, isExpanded }">
      <tr
        :class="`row-clickable ${item.status ? '' : 'red--text'}`"
        :data-cy="`${item.importKey}-upload-result`"
        @click="isExpanded ? (expanded = []) : (expanded = [item])"
      >
        <template v-for="header in headers">
          <td
            :key="header.value"
            data-cy="upload-result-status"
            v-if="header.value === 'status'"
          >
            {{ item.errorList.length ? "Error" : "Success" }}
          </td>
          <td :key="header.value" v-else>
            {{ item[header.value] }}
          </td>
        </template>
      </tr>
    </template>

    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="py-8">
        <v-divider></v-divider>
        <ul class="py-4">
          <li v-for="(error, index) in item.errorList" :key="index">
            {{ error }}
          </li>
        </ul>
        <v-divider></v-divider>
      </td>
    </template>

    <template v-slot:footer>
      <div class="mt-8 d-flex justify-space-between">
        <v-btn outlined color="primary" small @click="$emit('canceled')"
          >Back</v-btn
        >
        <v-btn outlined color="primary" small @click="$emit('completed')"
          >Finish</v-btn
        >
      </div>
    </template>
  </v-data-table>
</template>

<script>
import { get, keyBy } from "lodash";
import { mapGetters } from "vuex";

export default {
  computed: {
    attributeDefinitionList() {
      return this.attributeFilterByAttributeValue(
        "entityName",
        this.entityName
      );
    },

    attributeMapByName() {
      const { attributeDefinitionList } = this;

      return keyBy(attributeDefinitionList, "name");
    },
    attributeNameList() {
      const { attributeDefinitionList } = this;

      return attributeDefinitionList.map(definition => definition.name);
    },
    entityListExisting() {
      const { entityName } = this;

      return get(this.$store.state, `${entityName}.list`);
    },
    headerList() {
      return [
        {
          align: "start",
          text: "Status",
          value: "status",
        },
        { text: "Import Key", value: "importKey" },
      ];
    },
    ...mapGetters({
      attributeFilterByAttributeValue: "attribute/filterByAttributeValue",
    }),
  },
  data() {
    return {
      expanded: [],
    };
  },
  props: {
    entityList: {
      required: true,
      type: Array,
    },
    entityName: {
      required: true,
      type: String,
    },
  },
};
</script>

<style scoped>
.row-clickable {
  cursor: pointer;
}
</style>
